import { ReactElement } from 'react'
import { Stack, Typography } from '@mui/material'
import { CentimeterField } from '@ui/forms'
import EccentricitySymbol from './EccentricitySymbol'

interface Props {
  axis: 'y' | 'z'
  /** Form path of the load eccentricity object. */
  loadEccentricityPath: string
  disabled?: boolean
}

/** One eccentricity input (cm) with its symbol as label to the left. */
const EccentricityField = ({ axis, loadEccentricityPath, disabled }: Props): ReactElement => (
  <Stack direction="row" spacing={1} alignItems="baseline">
    <Typography variant="body2" sx={{ flexShrink: 0 }}>
      <EccentricitySymbol axis={axis} />
    </Typography>
    <CentimeterField
      name={`${loadEccentricityPath}.e_${axis}`}
      hideFormControl
      twoDecimalPlaces
      disabled={disabled}
      sx={{ width: 120 }}
      data-cy={`load-eccentricity-e-${axis}`}
    />
  </Stack>
)

export default EccentricityField
